module.exports = __webpack_public_path__ + "img/max-file-content-configure.2c28f847.svg";